import { GridValueFormatterParams } from '@mui/x-data-grid';
import moment from 'moment';
import React from 'react';
import { useTranslation } from '../../../contexts/translation';
import { useTimezoneDialog } from '../../../hooks/useTimezoneDialog';
import { PerformanceComment } from '../../../types/app/performanceComment.types';
import { dateTimeShowFormat } from '../../../types/core/date.types';
import { DataGridTable } from '../../core/DataGridTable/DataGridTable';

interface Props {
  data?: PerformanceComment[];
}

export function PerformanceCommentTable({ data }: Props) {
  const { t } = useTranslation();
  const { timezone } = useTimezoneDialog();

  const columns = [
    {
      headerName: t(`page.dashboard.performance-comment.table-col-1`),
      field: 'assetName',
      width: 200,
      renderCell: (data: any) => {
        return (
          <span style={{ textOverflow: 'ellipsis', overflow: 'hidden' }} title={data.value}>
            {data.value}
          </span>
        );
      },
    },
    {
      headerName: t(`page.dashboard.performance-comment.table-col-2`),
      field: 'category',
      minWidth: 150,
      flex: 1,
      renderCell: (data: any) => {
        return (
          <span style={{ textOverflow: 'ellipsis', overflow: 'hidden' }} title={data.value}>
            {data.value}
          </span>
        );
      },
    },
    {
      headerName: t(`page.dashboard.performance-comment.table-col-3`),
      field: 'comment',
      flex: 1.5,
      renderCell: (data: any) => {
        return (
          <div style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }} title={data.value}>
            {data.value}
          </div>
        );
      },
    },
    { headerName: t(`page.dashboard.performance-comment.table-col-4`), field: 'qty', width: 100 },
    {
      headerName: t(`page.dashboard.performance-comment.table-col-5`),
      field: 'updated',
      width: 200,
      valueFormatter: (params: GridValueFormatterParams) => {
        if (params.value)
          return moment.utc(params.value.toString()).tz(timezone.value).format(dateTimeShowFormat);
      },
    },
  ];
  return (
    <>
      <DataGridTable data={data} columns={columns} pageSize={5} rowsPerPageOptions={100} autoRowHeight />
    </>
  );
}
